export default __webpack_public_path__ + "static/media/white-kite-shape.d58d96ea.svg";